var render = function render(){var _vm=this,_c=_vm._self._c;return _c('messages',{attrs:{"ignore-scope":['news'],"page-size":"15","ignore-staff":"","message-id":_vm.messageId}})
}
var staticRenderFns = []

export { render, staticRenderFns }